export default {
  namespaced: true,
  state: {
    isDemoMode: false,
  },
  getters: {
    isDemoApp: (state) => state.isDemoMode,
  },
  mutations: {
    SET_DEMO_MODE(state, value) {
      state.isDemoMode = value;
    },
  },
  actions: {
    setDemoMode({ commit }, value) {
      commit('SET_DEMO_MODE', value);
    },
  },
};
